export enum CycleCountRuleType {
  Abc = "abc",
  Custom = "custom",
  Random = "random",
  Exception = "exception",
}
